import * as React from 'react';
import { LightboxState, initialState } from '../use-lightbox-reducer';

export const LightboxStateContext = React.createContext<LightboxState>(initialState);
